import get from 'lodash/get';
import { APP } from '../index';

/**
 * @param  {Object} state
 * @return {Array}
 */
export const getTicketTypeIds = (state) => {
    const app = get(state, `${APP}`);
    return get(app, 'ticketTypeIds') || [];
};
